import moment from 'moment-timezone';

export const fromNowOrNow = (
  m: moment.Moment,
  withAgoSuffix?: boolean,
): string => {
  const isLessThan25SecondsDiff = Math.abs(moment().diff(m)) < 25000;

  if (isLessThan25SecondsDiff) {
    // 25 seconds before or after now
    return 'just now';
  }

  return m.fromNow(withAgoSuffix);
};
